import { Injectable, Inject } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { StaticUrls, DocumentiImmobileUploader, Immobile, DocumentiRichiestaMutuoUploader, DocumentiRichiestaMutuoRichiedenteUploader, RichiestaMutuo } from '../models';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { MyCookieService } from './my-cookie.service';
import { environment } from 'environments/environment';

@Injectable()
export class FileService {
	constructor(private http: AuthHttp,
		@Inject(MyCookieService) private myCookieService: MyCookieService,
		private router: Router) { }

	uploadDocumenti(idImmobile: number, uploader: DocumentiImmobileUploader[]) {
		if(this.ifTokenNotExpired()){
			uploader.forEach((element, index) => {
				if(element.uploader.queue.length > 0){
					let options: FileUploaderOptions = element.uploader.options;
					options.url = StaticUrls._immobileDocumenti(idImmobile,element.servizio.tipologiaServizio.id);
					options.authTokenHeader = environment.headerName;
					if(this.myCookieService.token){
						options.authToken = localStorage.getItem(environment.tokenName);			
					}
					element.uploader.setOptions(options);
					element.uploader.uploadAll();
				}
			});
		}
	}

	uploadDocumentiObbligatori(immobile: Immobile, uploader: DocumentiImmobileUploader[]) {
		if(this.ifTokenNotExpired()){
			uploader.forEach((element, index) => {
				if(immobile.datiCatastali[index] != undefined && element.uploader.queue.length > 0){
					let options: FileUploaderOptions = element.uploader.options;
					options.url = StaticUrls._immobileDocumentiObbligatori(immobile.id,element.servizio.tipologiaServizio.id, immobile.datiCatastali[index].id);
					options.authTokenHeader = environment.headerName;
					if(this.myCookieService.token){
						options.authToken = localStorage.getItem(environment.tokenName);			
					}
					element.uploader.setOptions(options);
					element.uploader.uploadAll();
				}
			});
		}
	}

	uploadDocumentoCertificazionePrestazioneEnergetica(immobile: Immobile, uploader: FileUploader) {
		if(this.ifTokenNotExpired()){
			
			if(immobile.datiCatastali[0] != undefined && uploader.queue.length > 0){
				let options: FileUploaderOptions = uploader.options;

				options.url = StaticUrls._immobileDocumentoCertificazionePrestazioneEnergetica(immobile.id, immobile.datiCatastali[0].id);
				
				options.authTokenHeader = environment.headerName;
				if(this.myCookieService.token){
					options.authToken = localStorage.getItem(environment.tokenName);			
				}
				uploader.setOptions(options);
				uploader.uploadAll();
				
			};
		}
	}

	uploadFoto(idImmobile: number, uploader: FileUploader) {
		if(this.ifTokenNotExpired()){ 
			let options: FileUploaderOptions = uploader.options;
			options.url = StaticUrls._immobileFoto(idImmobile);
			options.authTokenHeader = environment.headerName;
			if(this.myCookieService.token){
				options.authToken = localStorage.getItem(environment.tokenName);			
			}
			uploader.setOptions(options);
			uploader.uploadAll();
		}
	}

	uploadVideo(idImmobile: number, uploader: FileUploader) {
		if(this.ifTokenNotExpired()){ 
			let options: FileUploaderOptions = uploader.options;
			options.url = StaticUrls._immobileVideo(idImmobile);
			options.authTokenHeader = environment.headerName;
			if(this.myCookieService.token){
				options.authToken = localStorage.getItem(environment.tokenName);			
			}
			uploader.setOptions(options);
			uploader.uploadAll();
		}
	}
	
	deleteVideo(idVideo: number) {
		if(this.ifTokenNotExpired()){ 
			return this.http.delete(StaticUrls._deleteVimeoVideo(idVideo))
			.map( (result:Response) => {
				return result;
			})
			.catch(this.handleError);
		}
	}
	
	deleteDocumentoImmobile(idDocumento: number): Observable<boolean> {
		if(this.myCookieService.token){
			if(this.ifTokenNotExpired()){
				return this.http.delete(StaticUrls._deleteDocumentoImmobile(idDocumento))
					.map( result => {
						if (result.status === 200) {
							return true;
						} 
						return false;
					})
					.catch(this.handleError);
			}
		}
	}

	deleteDocumentoImmobileObbligatorio(idDocumento: number, idDatoCatastale: number): Observable<boolean> {
		if(this.myCookieService.token){
			if(this.ifTokenNotExpired()){
				return this.http.delete(StaticUrls._deleteDocumentoImmobileObbligatorio(idDocumento, idDatoCatastale))
					.map( result => {
						if (result.status === 200) {
							return true;
						} 
						return false;
					})
					.catch(this.handleError);
			}
		}
	}

	deleteDocumentoIdentita(username: string) {
		if(this.myCookieService.token){
			if(this.ifTokenNotExpired()){

				return this.http.delete(StaticUrls._deleteDocumentoIdentitaUtente(username))
				.map( response => {
					return response;
				})
				.catch(this.handleError);
			}
		}
	}

	deleteVisuraCamerale(username: string) {
		if(this.myCookieService.token){
			if(this.ifTokenNotExpired()){

				return this.http.delete(StaticUrls._deleteVisuraCameraleUtente(username))
				.map( response => {
					return response;
				})
				.catch(this.handleError);
			}
		}
	}

	deleteFotoImmobile (idImmobile: number, nomeDoc: string): Observable<boolean> {
		if(this.myCookieService.token){
			if(this.ifTokenNotExpired()){

				return this.http.delete(StaticUrls._deleteFotoImmobile(idImmobile, nomeDoc))
					.map( result => {
						if (result.status === 200) {
							return true;
						} 
						return false;
					})
					.catch(this.handleError);
			}
		}
	}

	deletePlanimetriaImmobile (idImmobile: number, nomeDoc: string): Observable<boolean> {
		if(this.myCookieService.token){
			if(this.ifTokenNotExpired()){
				return this.http.delete(StaticUrls._deletePlanimetriaImmobile(idImmobile, nomeDoc))
					.map( result => {
						if (result.status === 200) {
							return true;
						} 
						return false;
					})
					.catch(this.handleError);
			}
		}
	}

	deleteCv (id: number): Observable<Response> {
		if(this.myCookieService.token){
			if(this.ifTokenNotExpired()){
				return this.http.delete(StaticUrls._deleteCv(id))
					.map( result => { return result });
			}
		}
	}

	deleteVc (id: number): Observable<Response> {
		if(this.myCookieService.token){
			if(this.ifTokenNotExpired()){
				return this.http.delete(StaticUrls._deleteVc(id))
					.map( result => { return result });
			}
		}
	}

	deleteContratto (id: number): Observable<Response> {
		if(this.myCookieService.token){
			if(this.ifTokenNotExpired()){
				return this.http.delete(StaticUrls._deleteContratto(id))
					.map( result => { return result });
			}
		}
	}

	uploadDocumentiRichiestaMutuo(idRichiestaMutuo: number, uploader: Array<DocumentiRichiestaMutuoUploader>) {
		if(this.ifTokenNotExpired()){
			uploader.forEach((element) => {
				if(element.uploader.queue.length > 0){
					let options: FileUploaderOptions = element.uploader.options;
					options.url = StaticUrls.richiesta_mutuo_doc(idRichiestaMutuo,element.tipologia.id);
					options.authTokenHeader = environment.headerName;
					if(this.myCookieService.token){
						options.authToken = localStorage.getItem(environment.tokenName);			
					}
					element.uploader.setOptions(options);
					element.uploader.uploadAll();
				}
			});
		}
	}

	uploadDocumentiRichiestaRichiedenteMutuo(richiesta: RichiestaMutuo, uploader: Array<DocumentiRichiestaMutuoRichiedenteUploader>) {
		if(this.ifTokenNotExpired()){
			uploader.forEach( (val, index) => {
				val.mapFileUploader.forEach(valMap => {
					valMap.forEach(element => {
						if(element.uploader.queue.length > 0) {
							let options: FileUploaderOptions = element.uploader.options;
							options.url = StaticUrls.richiesta_mutuo_doc_richiedente(richiesta.id, richiesta.richiedenti[index].id, element.tipologia.id);
							options.authTokenHeader = environment.headerName;
							if(this.myCookieService.token){
								options.authToken = localStorage.getItem(environment.tokenName);			
							}
							element.uploader.setOptions(options);
							element.uploader.uploadAll();
						}
					});
				});
			});
		}
	}

	uploadDocumentiRichiestaMutuoNa(idRichiestaMutuo: number, uploader: Array<DocumentiRichiestaMutuoUploader>) {
		uploader.forEach((element) => {
			if(element.uploader.queue.length > 0){
				let options: FileUploaderOptions = element.uploader.options;
				options.url = StaticUrls.richiesta_mutuo_doc_na(idRichiestaMutuo,element.tipologia.id);
				element.uploader.setOptions(options);
				element.uploader.uploadAll();
			}
		});
	}

	uploadDocumentiRichiestaRichiedenteMutuoNa(richiesta: RichiestaMutuo, uploader: Array<DocumentiRichiestaMutuoRichiedenteUploader>) {
		uploader.forEach( (val, index: number) => {
			val.mapFileUploader.forEach( (valMap) => {
				valMap.forEach( (element) => {
					if(element.uploader.queue.length > 0) {
						let options: FileUploaderOptions = element.uploader.options;
						options.url = StaticUrls.richiesta_mutuo_doc_richiedente_na(richiesta.id, richiesta.richiedenti[index].id, element.tipologia.id);
						element.uploader.setOptions(options);
						element.uploader.uploadAll();
					}
				});
			});
		});
	}

	deleteDocumentoRichiesta(id: number): Observable<Response> {
		if(this.myCookieService.token){
			if(this.ifTokenNotExpired()){
				return this.http.delete(StaticUrls._deleteDocumentoRichiesta(id))
					.map( result => { return result });
			}
		}
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return Observable.throw(errMsg);
	}

	private ifTokenNotExpired() {
		if(this.myCookieService.token){
			if (!tokenNotExpired(environment.tokenName)) {
				this.router.navigate(['login']);
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/file.service.ts